export const fontFamilyBase = 'var(--font-family-base)';
export const fontFamilyFallback = 'Lato, sans-serif';
